import React from 'react';
import { SlIcon } from '@shoelace-style/shoelace/dist/react';
import { TAB_EMPTY_COPY } from '../config';

const FILTERED_COPY = {
  title: 'No creatives match these filters',
  line: 'Try a different date range, sub-type or search term.',
};

const EmptyState = ({ tab, filtered = false, onClearFilters }) => {
  const copy = filtered ? FILTERED_COPY : TAB_EMPTY_COPY[tab] || TAB_EMPTY_COPY.assigned;

  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
        <SlIcon
          library="lucide"
          name={filtered ? 'search-x' : 'inbox'}
          className="text-slate-400"
          style={{ fontSize: '26px' }}
        />
      </div>
      <h3 className="text-sm font-semibold text-slate-800">{copy.title}</h3>
      <p className="mt-1 max-w-sm text-sm text-slate-500">{copy.line}</p>
      {filtered && typeof onClearFilters === 'function' && (
        <button
          type="button"
          onClick={onClearFilters}
          className="mt-4 rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default EmptyState;
